export default {"src":"/developer/_next/static/media/ChevronDown.47839c9f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};